/*
 *  (c) 2015 - 2024 ENISCO by FORCAM GmbH
 */

import {useSelector} from 'react-redux'
import {AppRootState} from '../model/config'

const useQuickLaunchType = () => {
  const value = useSelector((state: AppRootState) => state.app.profile?.quickLaunchType) ?? 'left'

  return [value]
}

export default useQuickLaunchType
